<script>
export default {
  name: 'view-shipping-card',
  props: {
    shippingAddress: {
      type: Object
    }
  }
}
</script>

<template>
  <div class="order-detail__card">
    <div class="order-detail__meta-row mb-0">
      <i class="mdi mdi-cube-send order-detail__meta-icon" />
      <template v-if="!!shippingAddress">
        <div>
          <h6 class="order-detail__meta-label">
            {{ $t('ship to') }}
          </h6>
          <p class="order-detail__meta-value mb-0">
            {{ shippingAddress.company_name }}
          </p>
          <p class="order-detail__meta-sub mb-0">
            {{ shippingAddress.street }} {{ shippingAddress.number }},<br />
            {{ shippingAddress.country_code }}-{{ shippingAddress.zipcode }}
            {{ shippingAddress.city }}
          </p>
        </div>
      </template>
      <template v-else>
        <h6 class="order-detail__meta-label mb-0">
          {{ $t('no shipping') }}
        </h6>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.order-detail__card {
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
  padding: 1.25rem 1.35rem;
}

.order-detail__meta-row {
  display: flex;
  align-items: flex-start;
}

.order-detail__meta-icon {
  color: #94a3b8;
  font-size: 1rem;
  margin-right: 0.85rem;
  margin-top: 0.15rem;
  width: 1rem;
  flex-shrink: 0;
}

.order-detail__meta-label {
  color: #94a3b8;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin-bottom: 0.2rem;
}

.order-detail__meta-value {
  color: #0f172a;
  font-size: 0.9rem;
  font-weight: 500;
}

.order-detail__meta-sub {
  color: #94a3b8;
  font-size: 0.8rem;
}
</style>
